import { createUseMutationHook } from '../../../hooks/createUseMutationHook';

export const useDeleteDocument = createUseMutationHook(
    'person_document_delete',
    (_document_id, person_id) => [
        ['person_document_list', person_id],
    ],
);
